import axios from "axios"

const gateway = axios.create({
    baseURL: process.env.VUE_APP_PICA_GATEWAY_BASE_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
})

gateway.interceptors.request.use((config) => {
    const token = localStorage.getItem('token')
    const tokenType = localStorage.getItem('token_type') || 'Token'
    if (token) {
        config.headers['Authorization'] = `${tokenType} ${token}`
    }
    return config
})

export default {
    sendEvent(token, apiKey) {
        return gateway.post('/fs/events/', {token}, {
            headers: {'x-api-key': apiKey}
        })
    }
}
